export const validEncounterColumns = [
    {
        Header: 'Name',
        accessor: 'name',
        enableFilter: true,
    },
    {
        Header: 'Duration',
        accessor: 'duration',
        disableSortBy: true,
        enableFilter: true,
        type: 'number'
    },
]